import type { TooltipProps } from "antd";

/** Short help shown in tooltips on home card and /glucose-readings */
export const GLUCOSE_READING_TOOLTIPS = {
  cgm:
    "CGM = Continuous Glucose Monitor. This is the live value from your sensor (mg/dL). Add it so meal predictions match how your sugar actually moves.",
  fingerPrick:
    "Finger prick = blood drop on a strip with a home glucometer (mg/dL). Use your most recent check, especially if you do not wear a CGM.",
  fasting:
    "Fasting glucose is measured after at least ~8 hours without food (mg/dL). Many people aim near 70–99, but your doctor sets your personal target.",
  hba1c:
    "HbA1c reflects average blood sugar over about 3 months (%). Under ~5.7% is often considered normal; 5.7–6.4% is higher risk; 6.5%+ usually means diabetes—confirm with your care team.",
} as const;

/** Mobile-friendly tooltips: tap (click) or hover; readable width on small screens */
export const GLUCOSE_READING_TOOLTIP_PROPS: Pick<
  TooltipProps,
  "trigger" | "destroyTooltipOnHide" | "mouseLeaveDelay" | "overlayStyle" | "overlayInnerStyle"
> = {
  trigger: ["hover", "click"],
  destroyTooltipOnHide: true,
  mouseLeaveDelay: 0.2,
  overlayStyle: { maxWidth: "min(calc(100vw - 1.5rem), 22rem)" },
  overlayInnerStyle: {
    fontSize: "var(--font-size-xs)",
    lineHeight: 1.45,
    padding: "10px 12px",
  },
};
